import React from 'react';
import { Helmet } from 'react-helmet-async';
import Button from './Button';
import ServiceShowcase from './ServiceShowcase';
import { BRAND, brandify } from '../brandConfig';

const LogosPage = ({ navigate }) => {
  return (
    <div className="py-32 max-w-[95vw] mx-auto px-4 md:px-8 bg-background min-h-screen flex flex-col justify-between">
      <Helmet>
        <title>{`Logo & Brand Identity Design | ${BRAND}`}</title>
        <meta name="description" content={brandify('Wind Marketing designs logos and brand identity systems that command instant recognition. From visual anchor to complete brand system — identity design that cuts through the noise.')} />
        <meta name="keywords" content={`logo design agency, brand identity design, custom logo design, brand visual identity, ${BRAND} logo design`} />
        <link rel="canonical" href="https://www.wind-marketing.com/logos" />
        <meta property="og:title" content={`Logo & Brand Identity Design • ${BRAND}`} />
        <meta property="og:description" content={brandify('Wind Marketing designs logos and brand identity systems that command instant recognition and cut through the noise.')} />
        <meta property="og:url" content="https://www.wind-marketing.com/logos" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Logo & Brand Identity Design",
            "provider": {
              "@type": "Organization",
              "name": "${BRAND}",
              "url": "https://www.wind-marketing.com"
            },
            "description": "${brandify('Custom logo design and full visual brand identity systems for growth-stage businesses. Wind Marketing creates the visual anchor that makes your brand instantly recognizable and unforgettable in a crowded marketplace.')}",
            "url": "https://www.wind-marketing.com/logos",
            "serviceType": "Graphic Design",
            "areaServed": "Worldwide"
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What does ${BRAND} deliver in a logo design project?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${brandify('Wind Marketing delivers a complete brand identity package including the primary logo, alternate logo variations, color palette, typography system, and brand usage guidelines. Everything your team needs to present a consistent, professional brand across all channels.')}"
                }
              },
              {
                "@type": "Question",
                "name": "Can ${BRAND} redesign an existing logo?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${brandify('Yes. Wind Marketing works with both new brands building from scratch and established businesses looking to modernize or evolve their visual identity. The process starts with a discovery session to understand your brand values and goals.')}"
                }
              }
            ]
          }
        `}</script>
      </Helmet>
      {/* Main Content Area */}
      <div className="max-w-4xl mx-auto mt-12 mb-20 flex-grow w-full">
        {/* Breadcrumb / Back button */}


        {/* Header Section */}
        <div className="w-full mb-27">
          <h1 
            className="text-4.5xl whitespace-nowrap sm:text-6xl md:text-8xl lg:text-9xl font-bold uppercase tracking-tighter leading-none mb-8 text-foreground"
            style={{ fontFamily: "'Poppins Black', sans-serif" }}
          >
            LOGOS
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-medium">
            A logo isn't just a graphic; it's the visual anchor, the immediate signifier, and the ultimate shorthand for everything your brand represents. It's the first thing remembered and the last thing forgotten. In a crowded marketplace, a strong logo cuts through the noise and commands instant recognition.
          </p>
        </div>

        <ServiceShowcase currentPath="/logos" navigate={navigate} />

        {/* Interactive Buttons */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-12">
          <Button 
            size="large"
            onClick={() => navigate('/pay', { plan: 'logo' })}
          >
            Purchase a Logo $54.99
          </Button>
          <Button 
            variant="outline"
            size="large"
            onClick={() => navigate('/contact', { serviceInterest: 'logo design' })}
          >
            Start Your Identity Project
          </Button>
          <Button 
            variant="outline" 
            size="large"
            onClick={() => navigate('/work')}
          >
            OUR SERVICES
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LogosPage;
